import * as actionTypes from "../../Action/actionTypes";

const initialState = {
 result: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.QUESTION_HANDLER:
        return {
          ...state,
          result: action.value
        };
    default:
      return state;
  }
};

export default reducer;
